import { useEffect, useState } from "react";
import Header from "./Header";
import Card from "./Card";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAppMarket } from "../../../services/useAppMarket";

// Import styled components
import {
  Container,
  TitleContainer,
  MainTitle,
  SubTitle,
  MainSection,
  TabsContainer,
  Tab,
  SearchSection,
  TitleGroup,
  SectionTitle,
  SectionSubtitle,
  SearchWrapper,
  SearchInput,
  SearchIcon,
  CardsGrid,
  CardWrapper,
  NoResults,
} from "../styles/AllAplications";
import { LoadingWrapper } from "@components";
import CardSkeleton from "./CardSkeleton";

const AllApplications = () => {
  const { GetAllMarketPlaceQuery } = useAppMarket();

  const navigate = useNavigate();
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const isRtl = language === "ar";
  const [searchQuery, setSearchQuery] = useState("");
  // const [filteredCards, setFilteredCards] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const { data: apps, isLoading } = GetAllMarketPlaceQuery(searchQuery);

  const headers = [
    t("AppMarket.AllApplications"),
    t("AppMarket.MarketingTools"),
    t("AppMarket.CommunicationTools"),
    t("AppMarket.FinancialTools"),
    t("AppMarket.ReservationTools"),
    t("AppMarket.SmartLockTools"),
  ];

  return (
    <Container>
      <TitleContainer $isRtl={isRtl}>
        <MainTitle>{t("AppMarket.Title")}</MainTitle>
        <SubTitle>{t("AppMarket.SubTitle")}</SubTitle>
      </TitleContainer>

      <MainSection>
        <TabsContainer>
          {headers.map((tab, index) => (
            <Tab
              key={`${tab}-${index}`}
              $isActive={activeTab === index}
              onClick={() => setActiveTab(index)}
            >
              <Header Title={tab} />
            </Tab>
          ))}
        </TabsContainer>
        <SearchSection $isRtl={isRtl}>
          <TitleGroup>
            <span>
              <SectionTitle>{t("AppMarket.ApplicationsAndTools")}</SectionTitle>
              <SectionSubtitle>
                {t("AppMarket.EnhanceYourWorkFlow")}
              </SectionSubtitle>
            </span>
          </TitleGroup>
          <SearchWrapper>
            <SearchInput
              onChange={(e) => setSearchQuery(e.target.value)}
              value={searchQuery}
              placeholder={t("AppMarket.SearchForApplication")}
            />
            <SearchIcon $isRtl={isRtl} />
          </SearchWrapper>
        </SearchSection>

        <CardsGrid>
          {isLoading
            ? Array.from({ length: 6 }).map((_, i) => <CardSkeleton key={i} />)
            : apps?.result?.length > 0
              ? apps?.result?.map((item: any) => (
                  <CardWrapper key={item.id}>
                    <Card
                      onPress={() => navigate(`/apps-Details/${item.id}`)}
                      status={item.status as number}
                      description={
                        isRtl ? item?.descriptionAr : item?.descriptionEn
                      }
                      title={isRtl ? item?.nameAr : item?.nameEn}
                      icon={item?.logoUrl}
                    />
                  </CardWrapper>
                ))
              : null}
        </CardsGrid>
      </MainSection>
    </Container>
  );
};

export default AllApplications;
